import {
  INDUSTRY_OPTIONS,
  type IndustryName,
} from '~/constants/onboardingPresets';

interface IndustryStepProps {
  onSelect: (industry: IndustryName) => void;
}

export function IndustryStep({ onSelect }: IndustryStepProps) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='grid grid-cols-1 gap-2 sm:grid-cols-2'>
        {INDUSTRY_OPTIONS.map((opt) => (
          <button
            key={opt}
            type='button'
            className='rounded border border-outline-variant bg-white px-3 py-2 text-left text-sm text-primary transition-all duration-200 hover:scale-102 hover:shadow-sm focus:scale-95 focus:shadow-none'
            onClick={() => onSelect(opt)}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}
